import React from "react";

type Movement = {
  _id: string;
  item?: { name?: string; sku?: string } | null;
  type: "in" | "out" | "adjustment";
  quantity: number;
  reason?: string;
  createdBy?: { name?: string } | null;
  createdAt: string;
};

type Props = {
  movements: Movement[];
  loading?: boolean;
  compact?: boolean;
};

const StockMovementTable: React.FC<Props> = ({ movements, loading, compact }) => (
  <div className="overflow-x-auto bg-white shadow rounded-xl" style={{ border: '1px solid var(--mui-palette-divider)' }}>
    <table className={`min-w-full ${compact ? 'text-xs' : 'text-sm'} text-slate-900`}>
      <thead>
        <tr className="bg-slate-100 text-slate-700">
          <th className="text-left py-2 px-3">Date</th>
          <th className="text-left py-2 px-3">Item</th>
          <th className="text-left py-2 px-3">SKU</th>
          <th className="text-left py-2 px-3">Type</th>
          <th className="text-left py-2 px-3">Qty</th>
          <th className="text-left py-2 px-3">Reason</th>
          <th className="text-left py-2 px-3">By</th>
        </tr>
      </thead>
      <tbody>
        {movements.map(m => (
          <tr key={m._id} className="border-t border-slate-200">
            <td className={compact ? 'py-1 px-2' : 'py-2 px-3'}>{new Date(m.createdAt).toLocaleString()}</td>
            <td className={compact ? 'py-1 px-2' : 'py-2 px-3'}>{m.item?.name || "-"}</td>
            <td className={compact ? 'py-1 px-2' : 'py-2 px-3'}>{m.item?.sku || "-"}</td>
            <td className={compact ? 'py-1 px-2 capitalize' : 'py-2 px-3 capitalize'}>{m.type}</td>
            <td className={compact ? 'py-1 px-2' : 'py-2 px-3'}>{m.quantity}</td>
            <td className={compact ? 'py-1 px-2' : 'py-2 px-3'}>{m.reason || "-"}</td>
            <td className={compact ? 'py-1 px-2' : 'py-2 px-3'}>{m.createdBy?.name || "-"}</td>
          </tr>
        ))}
        {!movements.length && !loading && (
          <tr className="border-t border-slate-200">
            <td colSpan={7} className="text-center text-slate-500 py-6">No movements found.</td>
          </tr>
        )}
      </tbody>
    </table>
    {loading && <div className="text-center py-6 text-blue-700">Loading...</div>}
  </div>
);

export default StockMovementTable;
